import API from './jsonapi-constants'

export const CONSTANTS = {
  ATTRIBUTE: {
    ID: 'price.id',
    TYPE: 'price.type',
    CURRENCYID: 'price.currencyid',
    DOMAIN: 'price.domain',
    QUANTITY: 'price.quantity',
    VALUE: 'price.value',
    COSTS: 'price.costs',
    REBATE: 'price.rebate',
    TAXVALUE: 'price.taxvalue',
    TAXRATES: 'price.taxrates',
    TAXRATE: 'price.taxrate',
    TAXFLAG: 'price.taxflag',
    STATUS: 'price.status',
    LABEL: 'price.label',
  },
  TYPE: {
    DEFAULT: 'default',
    LIST: 'list', // ToDo: list price can be removed
    DEALER_PRICE: 'dealer_price',
    ARCHIVE: 'archive',
  },
}

export const RELEVANT_PRICES = [CONSTANTS.TYPE.DEFAULT, CONSTANTS.TYPE.LIST]

export const PATHS = {
  ID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ID],
  TYPE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TYPE],
  CURRENCYID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.CURRENCYID],
  DOMAIN: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.DOMAIN],
  QUANTITY: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.QUANTITY],
  VALUE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.VALUE],
  COSTS: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.COSTS],
  REBATE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.REBATE],
  TAXVALUE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TAXVALUE],
  TAXRATES: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TAXRATES],
  TAXRATE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TAXRATE],
  TAXFLAG: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TAXFLAG],
  STATUS: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.STATUS],
  LABEL: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LABEL],
}

export default {
  ...CONSTANTS,
  PATHS,
  RELEVANT_PRICES,
}
